import React, { useContext } from "react";
import {
  EditorContext,
  ModalServiceContext,
  UploadContext,
  useDevService
} from "./../../ricos-context/index.js";
import { useWixInstanceService } from "./../../_shared/request-service-provider/wix-instance-context.js";
import { useEditorProps } from "./../../_shared/some-editor-props-context.js";
import { handleImageUpload } from "./../handle-image-upload.js";
import { IMAGE_EDITOR_MODAL_ID } from "../consts.js";
import { setupImageEditor } from "../imageStudio/image-editor-logic.js";
const ImageEditorModal = ({ nodeId, config, src }) => {
  const modalService = useContext(ModalServiceContext) || {};
  const { uploadService } = useContext(UploadContext) || {};
  const { getPublicCommands } = useContext(EditorContext);
  const devService = useDevService();
  const editorProps = useEditorProps();
  const wixInstance = useWixInstanceService();
  const id = "imageEditor";
  React.useEffect(() => {
    const onClose = () => {
      modalService.closeModal(IMAGE_EDITOR_MODAL_ID);
    };
    const onSave = (file) => {
      handleImageUpload({
        services: { uploadService, devService, editorProps, wixInstance },
        config,
        publicCommands: getPublicCommands(),
        nodeId,
        files: [file]
      });
      onClose();
    };
    config.onImageEditorOpen && config.onImageEditorOpen();
    setupImageEditor(
      config.imageEditorWixSettings ?? {},
      id,
      src,
      onSave,
      onClose
    );
  }, []);
  return /* @__PURE__ */ React.createElement("div", { id, nofocus: "true" });
};
var image_editor_modal_default = ImageEditorModal;
export {
  image_editor_modal_default as default
};
//# sourceMappingURL=image-editor-modal.js.map
